// NOTE: These breakpoints are only meant to be used using minWidth
export const breakpoints = {
  md: '601px',
  lg: '1024px',
};
